<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import ProjectsExhibitionServices from "../../services/ProjectsExhibition";
import loadingLogo from "../../assets/images/seda/logo-loader.svg";

export default {
  components: {},
  props: {},
  data() {
    const createGroup = (
      type,
      first,
      count,
      x,
      y,
      columns,
      width,
      height,
      gapX = 0.2,
      gapY = 0.4,
      premium = []
    ) =>
      Array.from({ length: count }, (_, index) => {
        const number = Array.isArray(first) ? first[index] : first + index;
        return {
          id: `${type}-${String(number).padStart(2, "0")}`,
          label: `${type}${number}`,
          type,
          x: x + (index % columns) * (width + gapX),
          y: y + Math.floor(index / columns) * (height + gapY),
          width,
          height,
          premium: premium.includes(number),
        };
      });

    return {
      loadingLogo,
      name: "",
      phone: "",
      selectedBooth: "",
      selectedBoothModel: "",
      selectedBoothNumber: "",
      reservedBoothIds: [],
      boothsLoading: true,
      boothsReady: false,
      boothLayout: [
        ...createGroup(
          "B",
          [75, 74, 73, 72, 71, 70, 69, 68, 67],
          9,
          33.7,
          2.5,
          9,
          4.1,
          5.2,
          0.15
        ),
        ...createGroup("B", [54, 55, 56, 57], 4, 23.8, 17.1, 4, 4, 5.2, 0.2),
        ...createGroup("B", [13, 14, 15, 16, 17], 5, 45.4, 17.1, 5, 4, 5.2, 0.2),
        ...createGroup("B", [53, 52, 51, 50], 4, 23.8, 23, 4, 4, 5.2, 0.2),
        ...createGroup("B", [12, 11, 10, 9, 8], 5, 45.4, 23, 5, 4, 5.2, 0.2),
        ...createGroup(
          "B",
          [42, 43, 44, 45, 46, 47, 48, 49],
          8,
          17.3,
          37.3,
          8,
          2.7,
          7.8,
          0.1
        ),
        ...createGroup(
          "B",
          [41, 40, 39, 38, 37, 36, 35, 34],
          8,
          17.3,
          52.2,
          8,
          2.7,
          7.8,
          0.1
        ),
        ...createGroup("A", [10, 11, 12, 13], 4, 45.1, 37.3, 4, 4.7, 7.8, 0.2),
        ...createGroup("B", [7], 1, 64.5, 37.3, 1, 2.7, 7.8),
        ...createGroup("A", [6, 7, 8, 9], 4, 45.1, 52.2, 4, 4.7, 7.8, 0.2),
        ...createGroup("B", [6], 1, 64.5, 52.2, 1, 2.7, 7.8),
        ...createGroup(
          "B",
          [26, 27, 28, 29, 30, 31, 32, 33],
          8,
          17.3,
          68.8,
          8,
          2.7,
          7.8,
          0.1
        ),
        ...createGroup(
          "B",
          [25, 24, 23, 22, 21, 20, 19, 18],
          8,
          17.3,
          76.8,
          8,
          2.7,
          7.8,
          0.1
        ),
        ...createGroup("A", [2, 3, 4, 5], 4, 45.1, 68.8, 4, 4.7, 7.8, 0.2),
        ...createGroup("B", [5], 1, 64.5, 68.8, 1, 2.7, 7.8),
        ...createGroup("A", [1], 1, 45.1, 76.8, 1, 4.7, 7.8),
        ...createGroup("B", [1], 1, 64.5, 76.8, 1, 2.7, 7.8),
        ...createGroup("B", [4, 3, 2], 3, 50, 76.8, 3, 4.7, 7.8, 0.2, 0.4, [2, 3, 4]),
        ...createGroup(
          "B",
          [66, 65, 64, 63, 62, 61, 60, 59, 58],
          9,
          33.7,
          91.5,
          9,
          4.1,
          5.2,
          0.15
        ),
      ],
    };
  },
  validations: {
    name: { required, minLength: minLength(8), maxLength: maxLength(100) },
    phone: {
      required,
      minLength: minLength(11),
      maxLength: maxLength(11),
      validPhone: (value) => /^07[789]\d{8}$/.test(value),
    },
    selectedBooth: { required },

    form: ["name", "phone", "selectedBooth"],
  },
  mounted() {
    this.loadReservedBooths();
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit(
        "on-validate",
        {
          name: this.name,
          phone: this.phone,
          selectedBooth: this.selectedBooth,
          selectedBoothModel: this.selectedBoothModel,
          selectedBoothNumber: this.selectedBoothNumber,
        },
        isValid
      );
      return isValid;
    },
    isBoothReserved(boothId) {
      return this.reservedBoothIds.includes(boothId);
    },
    normalizeReservedBooth(booth) {
      if (typeof booth === "string") {
        const match = /^([AB])-?0*(\d+)$/i.exec(booth.trim());
        if (match) {
          return `${match[1].toUpperCase()}-${String(Number(match[2])).padStart(2, "0")}`;
        }
      } else if (booth && typeof booth === "object") {
        const model = String(booth.model || "")
          .trim()
          .toUpperCase();
        const number = Number(booth.location);

        if (["A", "B"].includes(model) && Number.isInteger(number) && number > 0) {
          return `${model}-${String(number).padStart(2, "0")}`;
        }
      }

      throw new Error("بيانات البوث المحجوز المستلمة من الخادم غير صالحة.");
    },
    async loadReservedBooths() {
      this.boothsLoading = true;
      this.boothsReady = false;

      try {
        const response = await ProjectsExhibitionServices.getBooths();
        const projects = response.data && response.data.data;

        if (!Array.isArray(projects)) {
          throw new Error("تعذر قراءة قائمة البوثات المحجوزة من الخادم.");
        }

        this.reservedBoothIds = projects.map(this.normalizeReservedBooth);
        this.boothsReady = true;
      } catch (error) {
        this.$router.replace({ name: "404" });
      } finally {
        this.boothsLoading = false;
      }
    },
    selectBooth(booth) {
      if (!this.boothsReady || this.isBoothReserved(booth.id)) return;
      this.selectedBooth = booth.label;
      this.selectedBoothModel = booth.type;
      this.selectedBoothNumber = Number(booth.id.split("-")[1]);
      this.$v.selectedBooth.$touch();
    },
    chnageFile(e) {
      this[e.target.id] = e.target.files.length > 0 ? e.target.files[0] : null;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <!-- title -->

      <b-form-group class="col-md-6 mb-3" label="اسم صاحب المشروع : " label-for="name">
        <b-form-input
          id="name"
          type="text"
          placeholder="ادخل الاسم"
          v-model="name"
          :class="{ 'is-invalid': $v.name.$error }"
        ></b-form-input>
        <div v-if="$v.name.$error" class="invalid-feedback">
          <span v-if="!$v.name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name.maxLength">يجب أن يتكون الاسم من 70 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" رقم الهاتف  : " label-for="phone">
        <b-form-input
          id="phone"
          type="tel"
          inputmode="numeric"
          maxlength="11"
          placeholder="ادخل رقم الهاتف"
          v-model="phone"
          :class="{ 'is-invalid': $v.phone.$error }"
        ></b-form-input>
        <div v-if="$v.phone.$error" class="invalid-feedback">
          <span v-if="!$v.phone.required">هذا الحقل الزامي</span>
          <span v-if="!$v.phone.minLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
          >
          <span v-if="!$v.phone.maxLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
          >
          <span v-if="!$v.phone.validPhone"
            >يجب أن يبدأ رقم الهاتف بـ 077 أو 078 أو 079 ويتكون من أرقام فقط</span
          >
        </div>
      </b-form-group>
    </div>

    <section class="booth-booking" dir="rtl">
      <header class="booking-heading">
        <h4>اختر البوث المناسب لمشروعك</h4>
        <p>اختر بوثًا متاحًا من المخطط. المواقع وترتيب المناطق كما هي.</p>
      </header>
      <div class="booking-toolbar">
        <div class="booth-legend" aria-label="دليل حالة البوثات">
          <span><i class="legend-dot available-dot"></i>متاح</span>
          <span><i class="legend-dot selected-dot"></i>اختيارك</span>
          <span><i class="legend-dot reserved-dot"></i>محجوز</span>
        </div>
        <div class="selected-booth" :class="{ 'has-selection': selectedBooth }">
          <span>البوث المختار</span>
          <strong>{{ selectedBooth || "لم يتم الاختيار" }}</strong>
        </div>
      </div>
      <div v-if="boothsLoading" class="booths-loading" role="status">
        <span class="booths-loading-logo" aria-hidden="true">
          <img :src="loadingLogo" alt="" />
        </span>
        <span>جار التحميل ...</span>
      </div>
      <div v-else-if="boothsReady" class="plan-scroll">
        <div class="map-footer">
          <div class="map-legend">
            <span class="booth-plan-option booth-plan-a">
              <i class="legend-swatch type-a-swatch" aria-hidden="true"></i>
              <span class="booth-plan-details">
                <strong>النمط A</strong>
                <strong
                  ><span class="booth-detail-label">القياس:</span> 3 × 3.5 متر</strong
                >
                <b><span class="booth-detail-label">السعر:</span> 500,000 دينار عراقي</b>
              </span>
            </span>
            <span class="booth-plan-option booth-plan-b">
              <i class="legend-swatch type-b-swatch" aria-hidden="true"></i>
              <span class="booth-plan-details">
                <strong>النمط B</strong>
                <strong><span class="booth-detail-label">القياس:</span> 2 × 3 متر</strong>
                <b><span class="booth-detail-label">السعر:</span> 300,000 دينار عراقي</b>
              </span>
            </span>
          </div>
        </div>
        <div class="map-canvas" aria-label="مخطط توزيع الأكشاك في قاعة المعرض">
          <div class="map-room">
            <div class="map-region childcare">منطقة حضانة<br />وألعاب أطفال</div>
            <div class="map-region exhibition">
              منطقة كافتيريا وبيع<br />مشروبات وحلويات
            </div>
            <div class="vip-room"></div>
            <div class="map-region storage">مخزن</div>
            <div class="map-region workshop">منطقة اقامة ورش عملية</div>
            <div class="map-region vertical-room market">
              منطقة تصوير<br />ولقاءات اعلامية
            </div>
            <div class="map-region auditorium">قاعة ندوات</div>
            <div class="map-region vertical-room admin">منصة المحاورين<br />والضيوف</div>
            <div class="audience-seats"></div>
            <div class="map-booths">
              <button
                v-for="booth in boothLayout"
                :key="booth.id"
                type="button"
                class="booth-tile"
                :class="[
                  `booth-type-${booth.type.toLowerCase()}`,
                  {
                    'booth-premium': booth.premium,
                    'booth-reserved': isBoothReserved(booth.id),
                    'booth-selected': selectedBooth === booth.label,
                  },
                ]"
                :style="{
                  left: `${booth.x}%`,
                  top: `${booth.y}%`,
                  width: `${booth.width}%`,
                  height: `${booth.height}%`,
                }"
                :disabled="boothsLoading || !boothsReady || isBoothReserved(booth.id)"
                :aria-label="`${booth.label} - ${
                  !boothsReady
                    ? 'جارٍ التحميل'
                    : isBoothReserved(booth.id)
                    ? 'محجوز'
                    : 'متاح'
                }`"
                @click="selectBooth(booth)"
              >
                <span>{{ booth.label }}</span>
              </button>
            </div>
            <!-- <div class="vip-entry">↑<small>مدخل VIP</small></div> -->
            <div class="exit-entry">↓<small>باب الخروج</small></div>
            <div class="main-entry">↑<small>باب الدخول</small></div>
          </div>
        </div>
      </div>
      <div v-if="$v.selectedBooth.$error" class="booking-error">
        يرجى اختيار بوث متاح للمتابعة.
      </div>
    </section>
  </div>
  <!-- end page title -->
</template>

<style scoped>
.booth-booking {
  --ink: #172b4d;
  --muted: #708099;
  --line: #e5eaf1;
  margin: 0 0 2rem;
  padding: 1.5rem;
  border: 1px solid var(--line);
  border-radius: 18px;
  background: linear-gradient(145deg, #fff 0%, #f7f9fc 100%);
  color: var(--ink);
  box-shadow: 0 12px 34px rgba(31, 55, 91, 0.08);
}

.booking-heading {
  margin-bottom: 1rem;
  margin-top: 1rem;
  text-align: center;
}

.booking-heading h4 {
  margin: 0.35rem 0;
  font-weight: 800;
}

.booking-heading p,
.selected-booth span {
  margin: 0;
  color: var(--muted);
  font-size: 0.9rem;
}

.booking-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.booth-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  color: #4d5b70;
  font-size: 0.85rem;
}

.booth-legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.legend-dot {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
}

.available-dot {
  background: #fff;
  border: 2px solid #39a98e;
}
.selected-dot {
  background: #238b78;
}
.reserved-dot {
  background: #aab3c0;
}

.selected-booth {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fff;
}

.selected-booth strong {
  color: #9aa5b4;
}

.selected-booth.has-selection strong {
  color: #167663;
}

.floor-plan {
  overflow-x: auto;
  padding: 1rem;
  border: 2px solid #dce3eb;
  border-radius: 14px;
  background-color: #fff;
  background-image: linear-gradient(#f1f4f8 1px, transparent 1px),
    linear-gradient(90deg, #f1f4f8 1px, transparent 1px);
  background-size: 22px 22px;
}

.floor-plan-topline,
.floor-plan-bottomline {
  display: flex;
  justify-content: space-between;
  min-width: 650px;
  padding: 0.35rem 0.6rem;
  color: #8591a3;
  font-size: 0.75rem;
}

.floor-plan-topline {
  margin-bottom: 0.45rem;
  border-bottom: 2px solid #e0e6ed;
}

.floor-plan-bottomline {
  margin-top: 0.45rem;
  border-top: 2px solid #e0e6ed;
}

.entrance-label {
  color: #238b78;
  font-weight: 700;
}

.booth-row {
  min-width: 650px;
  margin: 0.45rem 0;
  padding: 0.5rem;
  border: 1px solid rgba(220, 227, 235, 0.9);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.88);
}

.booth-row-aisle {
  margin-top: 1.15rem;
}

.row-label {
  display: block;
  margin-bottom: 0.45rem;
  color: #8591a3;
  font-size: 0.7rem;
}

.booth-groups {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: clamp(0.8rem, 4vw, 3.5rem);
}

.booth-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.35rem;
  border: 1px solid #e8edf3;
  border-radius: 9px;
  background: rgba(247, 249, 252, 0.85);
}

.booth-tile {
  position: relative;
  display: flex;
  flex: 0 0 62px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  padding: 0.3rem;
  border: 1.5px solid #3779d5;
  border-radius: 6px;
  background: #f2f7ff;
  color: #2262b5;
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.booth-tile:hover:not(:disabled) {
  z-index: 1;
  transform: translateY(-2px);
  box-shadow: 0 5px 12px rgba(35, 93, 169, 0.18);
}

.booth-tile strong {
  font-size: 1.05rem;
  line-height: 1.1;
}
.booth-tile small {
  font-size: 0.62rem;
}

.booth-type-a {
  border-color: #d5a92d;
  background: #fff9e8;
  color: #a87900;
}

.booth-reserved,
.booth-reserved:hover {
  border-color: #b9c1cb;
  background: #e5e9ee;
  color: #7a8492;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.booth-selected,
.booth-selected:hover {
  border-color: #167663;
  background: #238b78;
  color: #fff;
  box-shadow: 0 0 0 3px rgba(35, 139, 120, 0.18);
}

.booth-status {
  position: absolute;
  inset: auto 2px 2px;
  font-size: 0.5rem;
}

.booking-error {
  text-align: center;
  margin-top: 0.35rem;
  color: #c0392b;
  font-size: 0.85rem;
}

.booths-loading {
  display: flex;
  min-height: 12rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  color: var(--muted);
}

.booths-loading-logo {
  display: block;
  width: min(14rem, 70vw);
  aspect-ratio: 942 / 362;
  animation: logo-draw 1.8s ease-in-out infinite;
}

.booths-loading-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

@keyframes logo-draw {
  0%,
  100% {
    opacity: 0.55;
    transform: scale(0.94);
  }
  55%,
  85% {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .booths-loading-logo {
    animation: none;
  }
}

@media (max-width: 600px) {
  .booth-booking {
    padding: 1rem 0.75rem;
  }
  .booking-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .booth-legend {
    gap: 0.7rem;
  }
  .selected-booth {
    align-self: stretch;
    justify-content: space-between;
  }
  .booth-tile {
    flex-basis: 55px;
    min-height: 54px;
  }
}

.booth-booking {
  margin: 0 0 2rem;
  padding: 0;
  overflow: hidden;
  border: 1px solid #ead9c4;
  border-radius: 8px;
  background: #f7ead8;
  color: #594331;
  box-shadow: 0 8px 25px rgba(103, 72, 43, 0.12);
}

.plan-scroll {
  overflow-x: auto;
  padding: 0.7rem 1rem 0;
}

.map-canvas {
  min-width: 850px;
  margin: 0 auto;
}

.map-room {
  position: relative;
  width: 100%;
  aspect-ratio: 1.95;
  overflow: hidden;
  border: 3px solid #98724f;
  border-radius: 12px;
  background: #fffdfa;
  box-shadow: inset 0 0 0 2px #e2d1b9;
}

.map-region,
.vip-room {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.35%;
  border: 2px solid;
  text-align: center;
  font-size: clamp(7px, 0.86vw, 13px);
  font-weight: 800;
  line-height: 1.2;
  box-shadow: 0 2px 4px rgba(76, 54, 36, 0.18);
}

.childcare {
  top: 1.5%;
  left: 0.5%;
  width: 13.7%;
  height: 44%;
  /* justify-content: flex-start;
  padding-left: 1.4%; */
  border-color: #bd3474;
  background: #fde5ee;
  color: #b53670;
}

.exhibition {
  top: 48.5%;
  left: 0.5%;
  width: 13.7%;
  height: 40%;
  border-color: #d28200;
  background: #fff2d9;
  color: #b46c00;
  font-size: clamp(6px, 0.7vw, 11px);
}

.vip-room {
  top: 89%;
  left: 0.5%;
  width: 13.7%;
  height: 9%;
  border-color: #98724f;
  border-radius: 10px;
  background: #dba266;
}

.storage {
  top: 2.5%;
  left: 72.3%;
  width: 24%;
  height: 16.5%;
  border-color: #76614e;
  background: #eee9e2;
  color: #685746;
  font-size: clamp(9px, 1.15vw, 16px);
}

.workshop {
  top: 20.5%;
  left: 72.3%;
  width: 18.6%;
  height: 24.5%;
  flex-direction: column;
  border-color: #4c974e;
  background: #e9f6e4;
  color: #4b9650;
}

.vertical-room {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.market {
  top: 20.5%;
  left: 91.2%;
  width: 5.1%;
  height: 24.5%;
  border-color: #7651c9;
  background: #eee8ff;
  color: #6847ac;
}

.auditorium {
  top: 52.5%;
  left: 72.3%;
  width: 18.6%;
  height: 30.5%;
  border-color: #386bc5;
  background: #e9f0ff;
  color: #3768b9;
}

.admin {
  top: 52.5%;
  left: 91.2%;
  width: 5.1%;
  height: 30.5%;
  border-color: #c77b16;
  background: #fff0d8;
  color: #a76612;
}

.map-booths {
  position: absolute;
  z-index: 4;
  inset: 0;
}

.map-room .booth-tile {
  position: absolute;
  display: flex;
  flex: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  padding: 0;
  border: 1px solid #f9ffff;
  border-radius: 4px;
  background: linear-gradient(145deg, #53b6ca, #167d98);
  color: #fff;
  font-size: clamp(6px, 0.78vw, 12px);
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 2px 3px rgba(28, 64, 74, 0.35);
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.15s ease;
}

.map-room .booth-tile:hover:not(:disabled) {
  z-index: 5;
  filter: brightness(1.08);
  transform: translateY(-2px);
}

.map-room .booth-type-a {
  border-color: #fff4ca;
  background: linear-gradient(145deg, #ffd75e, #f1a900);
  color: #60451d;
}

.map-room .booth-premium {
  border-color: #fff0e6;
  background: linear-gradient(145deg, #ff966b, #e95930);
  color: #fff;
}

.map-room .booth-reserved,
.map-room .booth-reserved:hover {
  border-color: #d5d9de;
  background: #aeb7c2;
  color: #fff;
  cursor: not-allowed;
  filter: none;
  transform: none;
}

.map-room .booth-selected,
.map-room .booth-selected:hover {
  z-index: 6;
  outline: 3px solid #37a77c;
  outline-offset: 1px;
  filter: brightness(1.08);
  transform: translateY(-2px);
}

.vip-entry,
.exit-entry,
.main-entry {
  position: absolute;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: clamp(17px, 2.5vw, 34px);
  font-weight: 800;
  line-height: 1;
}

/* .vip-entry {
  bottom: 1%;
  left: 23%;
  color: #bd2a9b;
} */
.exit-entry {
  right: 18%;
  bottom: 1%;
  color: #2a9b51;
}
.main-entry {
  right: 7%;
  bottom: 1%;
  color: #e63333;
}

.vip-entry small,
.exit-entry small,
.main-entry small {
  font-size: clamp(7px, 0.85vw, 13px);
  white-space: nowrap;
}

.map-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0rem 0.2rem 0.4rem;
  color: #826c55;
  font-size: clamp(0.7rem, 1vw, 0.9rem);
}

.map-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
}
.map-legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 700;
}

.legend-swatch {
  display: inline-block;
  width: 28px;
  height: 18px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(76, 54, 36, 0.3);
}

.type-a-swatch {
  background: #f6b51d;
}
.type-b-swatch {
  background: #2694ad;
}

.booking-toolbar {
  margin: 0;
  padding: 0.6rem 1rem;
  border-top: 1px solid #ead9c4;
  background: rgba(255, 253, 250, 0.75);
}

.selected-booth {
  border-color: #e5d5c2;
}
.booking-error {
  padding: 0 1rem 0.7rem;
}

@media (max-width: 600px) {
  .plan-scroll {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .map-canvas {
    min-width: 850px;
  }
  .map-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .map-legend {
    justify-content: flex-start;
  }
}

/* Responsive refinements: retain the exact floor-plan coordinates while scaling
   the entire plan to the available width on smaller screens. */
.booth-booking {
  border-color: #eadfce;
  border-radius: 14px;
  background: #fffdf9;
  box-shadow: 0 8px 24px rgba(66, 48, 28, 0.08);
}

.plan-scroll {
  overflow-x: auto;
  padding: clamp(0.4rem, 1.5vw, 1rem);
}

.map-canvas {
  width: 100%;
  min-width: 0;
}

.map-room {
  border: 2px solid #98724f;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(76, 54, 36, 0.08);
}

.map-region,
.vip-room {
  border-width: 1px;
  font-size: clamp(6px, 0.86vw, 13px);
}

.map-room .booth-tile {
  flex: none;
  flex-direction: row;
  min-width: 0;
  min-height: 0;
  padding: 0;
  border-radius: 3px;
  font-size: clamp(6px, 0.78vw, 12px);
}

.map-room .booth-tile:focus-visible {
  z-index: 7;
  outline: 2px solid #172b4d;
  outline-offset: 2px;
}

.map-footer {
  flex-wrap: wrap;
  padding: 0rem 0.25rem 0.4rem;
  font-size: clamp(0.65rem, 1vw, 0.85rem);
}

.map-legend {
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}

.map-legend span {
  font-size: clamp(0.65rem, 1vw, 0.85rem);
}

.legend-swatch {
  width: 1.4rem;
  height: 0.85rem;
}

.booking-toolbar {
  flex-wrap: wrap;
  margin: 0;
  padding: 0.75rem 1rem;
  border-top: 1px solid #eee5d9;
  background: transparent;
}

.selected-booth {
  padding: 0.45rem 0.7rem;
  border-color: #e7e0d7;
}

.booking-error {
  padding: 0 1rem 0.75rem;
}

@media (max-width: 768px) {
  .map-room {
    aspect-ratio: 1.65;
  }

  .map-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .map-legend {
    justify-content: flex-start;
  }

  .booking-toolbar {
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .map-room {
    aspect-ratio: 1.4;
  }

  .map-region,
  .vip-room {
    padding: 0.15%;
    line-height: 1.05;
  }

  .booth-legend {
    gap: 0.45rem 0.75rem;
    font-size: 0.75rem;
  }

  .selected-booth {
    width: 100%;
    justify-content: space-between;
  }
}

@media (prefers-reduced-motion: reduce) {
  .map-room .booth-tile {
    transition: none;
  }
}

/* Clean, contemporary visual layer; the floor-plan coordinates remain unchanged. */
.booth-booking {
  --map-ink: #202b3c;
  --map-muted: #728096;
  --map-border: #e5eaf0;
  overflow: hidden;
  border: 1px solid var(--map-border);
  border-radius: 18px;
  background: #fff;
  color: var(--map-ink);
  box-shadow: 0 14px 38px rgba(30, 45, 66, 0.08);
}

.plan-scroll {
  padding: clamp(0.65rem, 2vw, 1.25rem);
}

.map-room {
  border: 1px solid #cfd7e2;
  border-radius: 12px;
  background-color: #fbfcfe;
  box-shadow: none;
}

.map-region,
.vip-room {
  border-width: 1px;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
}

.childcare {
  border-color: #ebc6d4;
  background: #fff3f7;
  color: #98536e;
}

.exhibition {
  border-color: #ead8ba;
  background: #fff9ef;
  color: #967043;
}

.vip-room {
  border-color: #dcc8af;
  border-radius: 8px;
  background: #e9d2b5;
}

.storage {
  border-color: #ded8cf;
  background: #f3f1ed;
  color: #746b61;
}

.workshop {
  border-color: #c9dfcf;
  background: #f1f8f2;
  color: #52795b;
}

.market {
  border-color: #d8cfee;
  background: #f7f4fc;
  color: #70618e;
}

.auditorium {
  border-color: #cfdaef;
  background: #f1f5fc;
  color: #58729e;
}

.admin {
  border-color: #e7d7c1;
  background: #fbf6ed;
  color: #927349;
}

.audience-seats {
  background-image: radial-gradient(ellipse, #a5b8d6 0 42%, transparent 48%);
}

.map-room .booth-tile {
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  background: #3c96a9;
  color: #fff;
  box-shadow: 0 1px 3px rgba(26, 56, 66, 0.18);
  font-weight: 700;
}

.map-room .booth-tile:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 3px 8px rgba(27, 53, 72, 0.2);
}

.map-room .booth-type-a {
  border-color: rgba(255, 255, 255, 0.85);
  background: #e9b33c;
  color: #4e3d1d;
}

.map-room .booth-premium {
  background: #df7654;
  color: #fff;
}

.map-room .booth-reserved,
.map-room .booth-reserved:hover {
  background: #aab3bf;
  color: #fff;
}

.map-room .booth-selected,
.map-room .booth-selected:hover {
  outline: 2px solid #12836d;
  outline-offset: 1px;
  background: #16836e;
  color: #fff;
}

/* .vip-entry {
  color: #a3438e;
} */
.exit-entry {
  color: #38835a;
}
.main-entry {
  color: #bd5656;
}

.map-footer {
  color: var(--map-muted);
}

.legend-swatch {
  border: 0;
  border-radius: 4px;
  box-shadow: none;
}

.type-a-swatch {
  background: #e9b33c;
}
.type-b-swatch {
  background: #3c96a9;
}

.booking-toolbar {
  border-top-color: var(--map-border);
  background: #f8fafc;
}

.booth-legend {
  color: #59677b;
}

.selected-booth {
  border-color: var(--map-border);
  border-radius: 8px;
  background: #fff;
}

.selected-booth span {
  color: var(--map-muted);
}

.selected-booth.has-selection strong {
  color: var(--brand-teal-dark);
}

@media (max-width: 600px) {
  .map-room {
    aspect-ratio: 1.4;
  }

  .map-footer {
    gap: 0.6rem;
  }

  .booking-toolbar {
    gap: 0.7rem;
  }
}

/* Minimal visual refresh using the exhibition's teal and orange brand colors. */
.booth-booking {
  --brand-teal: #5dbfc9;
  --brand-teal-dark: #238f9a;
  --brand-orange: #f08642;
  --surface: #ffffff;
  --surface-soft: #f5fbfb;
  --border-soft: #dcebed;
  --text-main: #2b4653;
  --text-muted: #74868e;
  padding: clamp(0.75rem, 2vw, 1.35rem);
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  background: linear-gradient(155deg, var(--surface), var(--surface-soft));
  color: var(--text-main);
  box-shadow: 0 12px 32px rgba(43, 105, 113, 0.09);
}

.booking-heading {
  margin: 0.35rem 0 1.1rem;
}

.booking-heading h4 {
  color: var(--brand-teal-dark);
  font-size: clamp(1.05rem, 2vw, 1.35rem);
  font-weight: 800;
}

.booking-heading p {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.booking-toolbar {
  margin-bottom: 0.8rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  background: var(--surface);
}

.booth-legend {
  color: #536c75;
  font-size: 0.8rem;
}

.available-dot {
  border: 2px solid var(--brand-teal);
}

.selected-dot {
  background: var(--brand-teal-dark);
}

.reserved-dot {
  background: #b7c1c5;
}

.selected-booth {
  border-color: var(--border-soft);
  border-radius: 9px;
  background: #f7fbfb;
}

.selected-booth span {
  color: var(--text-muted);
}

.selected-booth.has-selection strong {
  color: var(--brand-teal-dark);
}

.plan-scroll {
  padding: 0.35rem;
  border: 1px solid var(--border-soft);
  border-radius: 14px;
  background: #f8fcfc;
  scrollbar-color: #9bd4d9 #edf5f5;
  scrollbar-width: thin;
}

.plan-scroll::-webkit-scrollbar {
  height: 8px;
}

.plan-scroll::-webkit-scrollbar-track {
  border-radius: 99px;
  background: #edf5f5;
}

.plan-scroll::-webkit-scrollbar-thumb {
  border-radius: 99px;
  background: #9bd4d9;
}

.map-canvas {
  padding: 0.25rem;
}

.map-room {
  border: 2px solid #b9dfe2;
  border-radius: 10px;
  background-color: #fff;
  background-image: linear-gradient(rgba(93, 191, 201, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(93, 191, 201, 0.035) 1px, transparent 1px);
  background-size: 24px 24px;
  box-shadow: none;
}

.map-region,
.vip-room {
  border-width: 1px;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
}

.childcare,
.exhibition {
  border-color: rgba(240, 134, 66, 0.55);
  background: #fff6ef;
  color: #a9653d;
}

.vip-room {
  border-color: rgba(240, 134, 66, 0.5);
  border-radius: 8px;
  background: #f8d7bd;
}

.storage,
.market,
.admin {
  border-color: #d5e7e9;
  background: #f4f9fa;
  color: #56747b;
}

.workshop {
  border-color: rgba(93, 191, 201, 0.55);
  background: #effafa;
  color: #39838b;
}

.auditorium {
  border-color: #d2e7e9;
  background: #f3f9fa;
  color: #507780;
}

.map-room .booth-tile {
  border: 1px solid rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  background: var(--brand-teal);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 1px 3px rgba(35, 115, 124, 0.2);
  transition: filter 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.map-room .booth-tile:hover:not(:disabled) {
  filter: brightness(1.04);
  box-shadow: 0 3px 8px rgba(35, 115, 124, 0.24);
}

.map-room .booth-type-a {
  background: var(--brand-orange);
  color: #fff;
}

.map-room .booth-premium {
  background: #d9684a;
  color: #fff;
}

.map-room .booth-reserved,
.map-room .booth-reserved:hover {
  border-color: #d4dcde;
  background: #b7c1c5;
  color: #fff;
}

.map-room .booth-selected,
.map-room .booth-selected:hover {
  z-index: 6;
  outline: 2px solid var(--brand-teal-dark);
  outline-offset: 1px;
  background: var(--brand-teal-dark);
  color: #fff;
  filter: none;
}

.map-room .booth-tile:focus-visible {
  z-index: 7;
  outline: 2px solid #234a55;
  outline-offset: 2px;
}

/* .vip-entry {
  color: var(--brand-orange);
} */

.exit-entry,
.main-entry {
  color: var(--brand-teal-dark);
}

.map-footer {
  justify-content: center;
  padding: 0.55rem 0.35rem 0.35rem;
  color: var(--text-muted);
}

.map-legend {
  width: 100%;
  justify-content: center;
  gap: 0.5rem 1rem;
}

.map-legend .booth-plan-option {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.map-legend span {
  color: #536c75;
  font-size: 0.78rem;
}

.legend-swatch {
  border: 0;
  border-radius: 4px;
  box-shadow: none;
}

.type-a-swatch {
  background: var(--brand-orange);
}

.type-b-swatch {
  background: var(--brand-teal);
}

.booking-error {
  margin-top: 0.6rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid #f0d7cc;
  border-radius: 9px;
  background: #fff8f4;
  color: #b96349;
}

@media (max-width: 600px) {
  .booth-booking {
    padding: 0.8rem;
    border-radius: 14px;
  }

  .booking-toolbar {
    padding: 0.65rem;
  }

  .map-canvas {
    padding: 0.15rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .map-room .booth-tile {
    transition: none;
  }
}

/* Final minimal polish for the floor plan; coordinates and form behavior stay untouched. */
section.booth-booking {
  border-color: #e3edef;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 26px rgba(37, 91, 99, 0.07);
}

.booking-heading h4 {
  color: #238f9a;
}

.booking-toolbar {
  border-color: #e7eff0;
  background: #f8fbfb;
}

.selected-booth {
  min-height: 42px;
  padding: 0.45rem 0.75rem;
  border-color: #e3edef;
  background: #fff;
}

.plan-scroll {
  border: 1px solid #e4edef;
  border-radius: 12px;
  background: #f8fbfb;
}

.map-canvas {
  padding: 0.35rem;
}

.map-room {
  border-color: #cfe3e5;
  border-radius: 8px;
  background-color: #fff;
  background-image: none;
  box-shadow: none;
}

.map-region,
.vip-room {
  border-radius: 5px;
  box-shadow: none;
  font-weight: 700;
}

.childcare,
.exhibition {
  border-color: #f3d9c8;
  background: #fff8f3;
  color: #a9653d;
}

.vip-room {
  border-color: #efc7a8;
  background: #fbe9da;
}

.storage,
.market,
.admin {
  border-color: #e0eaeb;
  background: #f7fafa;
  color: #617980;
}

.workshop,
.auditorium {
  border-color: #d3e8e9;
  background: #f2fafa;
  color: #49777d;
}

.map-room .booth-tile {
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(31, 82, 88, 0.16);
}

.map-room .booth-tile:hover:not(:disabled) {
  filter: brightness(1.05);
  box-shadow: 0 2px 6px rgba(31, 82, 88, 0.2);
}

.map-room .booth-reserved,
.map-room .booth-reserved:hover {
  background: #b7c1c5;
  color: #fff;
}

.map-footer {
  padding: 0.45rem 0.4rem 0.2rem;
}

.booking-error {
  border-color: #f1ddd4;
  background: #fff9f6;
}

@media (max-width: 600px) {
  section.booth-booking {
    border-radius: 13px;
  }

  .plan-scroll {
    padding: 0.25rem;
  }
}

/* Keep the floor plan at a readable fixed scale and scroll it inside its frame on narrow screens. */
.plan-scroll {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-inline: contain;
  touch-action: pan-x pan-y;
  scrollbar-width: thin;
  scrollbar-color: #9bd4d9 #edf5f5;
}

.map-canvas {
  width: 900px;
  min-width: 900px;
  margin: 0 auto;
}

.map-room {
  width: 100%;
  aspect-ratio: 1.95;
}

.map-room .booth-tile {
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
  touch-action: manipulation;
}

.map-region {
  font-size: 10px;
}

.map-region.exhibition {
  font-size: 9px;
}

.map-room .booth-tile:focus-visible {
  z-index: 8;
  outline: 2px solid #234a55;
  outline-offset: 2px;
}

.plan-scroll::-webkit-scrollbar {
  height: 8px;
}

.plan-scroll::-webkit-scrollbar-track {
  border-radius: 8px;
  background: #edf5f5;
}

.plan-scroll::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #9bd4d9;
}

.booth-plan-details strong .booth-detail-label,
.booth-plan-details b .booth-detail-label {
  color: #ff0000 !important;
}

.booth-plan-details strong .booth-detail-label {
  font-weight: 800;
}

.booth-plan-details b .booth-detail-label {
  color: #ff0000 !important;
  font-weight: 900;
}

@media (max-width: 600px) {
  .plan-scroll {
    padding: 0.25rem;
  }

  .map-canvas {
    width: 900px;
    min-width: 900px;
  }

  .map-room {
    aspect-ratio: 1.95;
  }
}
</style>
